import { trackOpenListingsFee } from "../../lib/tracking/trackNavigationEvents";

export default [
  {
    name: "دفع العمولة",
    icon: "Fees-colored",
    path: "/mlr",
  },
  {
    name: "الباقات",
    icon: "Packages-colored",
    path: "/payment-gateway/pricing-packages/",
    onClick: trackOpenListingsFee,
  },
  {
    name: "عقود إيجار",
    icon: "Contracts-colored",
    path: "/payment-gateway/ejar-fees/",
  },
  {
    name: "خدمات التمييز",
    icon: "WebFeatured-colored",
    path: "/user/campaigns",
  },
  {
    name: "خدمات المطورين",
    icon: "red-services-colored",
    path: "/payment-gateway/red-services",
  },
];
